import * as React from 'react';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import Style from 'style-it';
import JSX from './JSX.esm.js';

/* eslint-disable @typescript-eslint/naming-convention */
var AtomSection = function (_a) {
    var id = _a.id, _b = _a.fields, internalName = _b.internalName, html = _b.html, css = _b.css, analyticsEvents = _b.analyticsEvents, dataCy = _a["data-cy"];
    // https://github.com/facebook/react/issues/8838 this says we don't need to sanitize html
    // style it scopes css
    return (React.createElement(Style, null,
        css,
        React.createElement(BaseSectionWithAnalyticsContext, { analyticsEvents: analyticsEvents, className: "nv-container", "data-cy": dataCy, id: id, sectionName: internalName, 
            /** position relative may be useful if use position absolute */
            style: { position: 'relative' } },
            React.createElement(JSX, { html: html }))));
};
/* eslint-enable @typescript-eslint/naming-convention */

export { AtomSection as default };
//# sourceMappingURL=AtomSection.esm.js.map
